import view from '../../view';

import registerInterruptionPoint from '../helpers/register-interruption-point';
import interruptReplaceElement from '../helpers/interrupt-replace-element';
import interruptDeleteElement from '../helpers/interrupt-delete-element';

const registerInterruptionPoints = () => {
  registerInterruptionPoint(view.actionTypes.DELETE_ELEMENT, interruptDeleteElement);
  registerInterruptionPoint(view.actionTypes.REPLACE_ELEMENT, interruptReplaceElement);
};

export default registerInterruptionPoints;
